import React, { useState } from "react";
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { Box, Button, Card, CssBaseline, FormControl, FormLabel, Paper, TextField, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router";
import Logo from '../images/logo.png'
import './style.css'
import { useDispatch } from "react-redux";
import { phoneAuth } from "../actions/authAction";

const Login = (props) => {
  const [mobileNumber, setMobileNumber] = useState();
  const [error, setError] = useState("")
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const handleLogin = async () => {
    const status = await dispatch(phoneAuth({mobileNumber}))
    if(status){
      navigate('otp')
    }
  }
  return (
    <div className="loginCoverImg">
      <Paper elevation={3} m={2} p={5} style={{}}>
        <Box className="css-rjh0ej" variant="outlined">
          <div className="brand-logo pb-4 text-center">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img style={{ height: 116, width: 220 }} className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
              {/* <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" /> */}
            </Link>
          </div>
          <Typography mt={2}
            component="h1"
            variant="h4"
            sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
          >
            Sign in
          </Typography>
          <Typography mt={2} mb={4}>{"Log in to your account to access the admin dashboard."}</Typography>
          <Box
            noValidate
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 2,
            }}
          >
            <FormControl >
              <FormLabel htmlFor="email">Mobile number</FormLabel>
              <TextField
                error={error}
                helperText={error}
                id="email"
                type="email"
                name="email"
                placeholder="An OTP will be sent to this number for verification."
                autoComplete="email"
                autoFocus
                required
                fullWidth
                variant="outlined"
                onChange={(event) => setMobileNumber(event.target.value)}
                color={error ? 'error' : 'primary'}
              />
            </FormControl>

            <Button style={{ marginTop: '12px', backgroundColor: '#4DA235' }}
              type="submit"
              fullWidth
              variant="contained"
              onClick={() => {handleLogin() }}
            >
              Sign in
            </Button>
            {/* <Link
              component="button"
              type="button"
              onClick={handleClickOpen}
              variant="body2"
              sx={{ alignSelf: 'center' }}
            >
              Forgot your password?
            </Link> */}
          </Box>
        </Box>
      </Paper>
    </div>


  )
}

export default Login;